export default "__VITE_ASSET__Bd8UOKY0__"